import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";

export const getRankList = (searchitem) => {
    let url = `${API.SearchRank}?rankName=${searchitem.Name}&PageNumber=${searchitem.PageNumber}&PageSize=${searchitem.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getSearchRankSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getSearchRankFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getAllRank = () => {
    let url = `${API.GetAllRank}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getSearchAllRankSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getSearchAllRankFailure",
                    error: "ERROR"
                })
            })
    }
}